import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ApiResponse } from 'src/constants/apiResponse';

const getLatestAlgorithmRequestVersion = (startOn: string, endOn: string) => async () => {
  const res = await axios.get<ApiResponse>(`/api/v3/latest_algorithm_request_version?start_on=${startOn}&end_on=${endOn}`);
  return res.data.data as unknown as number;
};

export const useQueryLatestAlgorithmRequestVersion = (startOn: string, endOn: string) => useQuery(
  ['useQueryLatestAlgorithmRequestVersion', { startOn, endOn, }],
  getLatestAlgorithmRequestVersion(startOn, endOn),
  {
    staleTime: Infinity,
  }
);
